import {
    useContext, useEffect,
    useMemo,
    useState,
} from 'react';
import {
    Card, Divider, Input, List, Menu, Modal, PageHeader, Space, notification,
} from 'antd';
import { updateIssue } from '../../../api/issues';
import { IssuesContext } from '../context/issues.context';

interface Props {
    handleActive: () => void;
    onChangeIssueType: (type: string) => void;
}

const { confirm } = Modal;

const { Search } = Input;

const IssueTypesList = ({
    handleActive,
    onChangeIssueType,
}: Props) => {
    const {
        item,
        data,
        setData,
        setItem,
        issuesTypes,
    } = useContext(IssuesContext);
    const [search, setSearch] = useState<string>('');

    const dataTypes = useMemo(() => issuesTypes.filter((type) => type.keyName.toLowerCase().includes(search.toLowerCase())), [issuesTypes, search]);

    const confirmChangeType = (type: any) => confirm({
        title: 'Change issue type',
        content: `Are you sure you want to change the issue type to "${type.keyName}"?`,
        onOk: async () => {
            try {
                const payload = {
                    type: type.keyName,
                    status: item?.status,
                    description: item?.description,
                    companyName: item?.bookingData?.businessName,
                    userID: item?.userID,
                    bookingNumericId: item?.bookingNumericId,
                    issuePublicID: item?.issuePublicID,
                    role: 'business',
                };
                const issueID = item?._id;
                updateIssue(issueID || '', payload)
                    .then((response) => {
                        notification.success({
                            message: 'Issue type updated successfully',
                        });
                        const newData = data.map((item) => {
                            if (item._id === issueID) {
                                return {
                                    ...item,
                                    type: type.keyName,
                                };
                            }
                            return item;
                        });
                        setData(newData);
                        setItem({
                            ...item,
                            ...response.data.data,
                        });
                        handleActive();
                    }).catch((error) => {
                        const description = error?.response?.data?.message || 'Something went wrong, please try again later';
                        notification.error({
                            message: 'Error',
                            description,
                        });
                    });
            } catch (error) {
                console.log(error);
                notification.error({
                    message: 'Error',
                    description: 'Something went wrong, please try again later',
                });
            }
        },
        onCancel: () => {
            if (!item?.type) return;
            onChangeIssueType(item?.type);
        },
        okText: 'Cambiar',
        cancelText: 'Cancelar',
        zIndex: 9999,
    });

    const changeIssueType = (type: any) => {
        onChangeIssueType(type.keyName);
        confirmChangeType(type);
    };

    const ITEMS = [
        {
            key: '1',
            label: (
                <Card
                    bordered
                    style={{
                        minWidth: 300,
                        maxWidth: 300,
                    }}
                >
                    <PageHeader
                        title="Issue types"
                        style={{
                            padding: 0,
                            paddingRight: 0,
                            width: '100%',
                            marginBottom: 12,
                        }}
                        extra={(
                            <span
                                style={{ cursor: 'pointer' }}
                                onClick={handleActive}
                            >
                                cerrar
                            </span>
                        )}
                    />

                    <Space direction="vertical" size={12} style={{ width: '100%' }}>
                        <Search
                            allowClear
                            enterButton
                            onChange={(e) => setSearch(e.target.value)}
                            placeholder="Search by name"
                        />
                        <div
                            style={{
                                width: '100%',
                                overflow: 'auto',
                                maxHeight: '20vh',
                            }}
                        >
                            {
                                issuesTypes.length === 0 ? (
                                    <div
                                        style={{
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            padding: '20px',
                                        }}
                                    >
                                        No issue types available
                                    </div>
                                ) : (
                                    <List
                                        size="small"
                                        dataSource={dataTypes}
                                        renderItem={(type) => (
                                            <List.Item
                                                style={{
                                                    cursor: 'pointer',
                                                    padding: '8px 12px',
                                                    borderRadius: 4,
                                                    marginBottom: 4,
                                                    backgroundColor: item?.type === type.keyName ? '#202020' : 'transparent',
                                                }}
                                                onClick={() => changeIssueType(type)}
                                            >
                                                <span>{type.keyName}</span>
                                            </List.Item>
                                        )}
                                    />
                                )
                            }
                        </div>
                    </Space>
                </Card>
            ),
        },
    ];

    return (
        <Menu
            items={ITEMS}
            style={{
                padding: 0,
                backgroundColor: 'transparent',
                border: 'none',
            }}
        />
    );
};

export default IssueTypesList;
